import { API } from '../../API/api';
import {types as productType} from '../../_constants/product/types';
import {
    updateTyreSizeConfiguratorFilterOptionsAction,
    updateTyreMotoSizeConfiguratorFilterOptionsAction
} from '../../_flux/actions/filter_options_actions';
import {
    tyreFilterOptionsStarted, tyreFilterOptionsSuccess, tyreFilterOptionsFailed,
    motoTyreFilterOptionsStarted, motoTyreFilterOptionsSuccess, motoTyreFilterOptionsFailed,
} from '../../_flux/actions/http_request/tyre_filter_options_actions';
import CatalogFilterStore from '../../_flux/stores/catalog_configurator_store';
import TyreFilterOptionsStore from '../../_flux/stores/configurator_filter_options_store/tyre';
import TyreMotoFilterOptionsStore from '../../_flux/stores/configurator_filter_options_store/tyre_moto';
import {updateFilterOptionsAction} from '../../_flux/actions/filter_options_actions';

export const getFilterOptions = (requestConfig, tyreType, doAutoOpen) => API
    .GET(requestConfig)
    .then((response) => {
        const pageOriginType = CatalogFilterStore.getState().pageOriginType;
        if (productType.TYRE_CAR === tyreType) {
            tyreFilterOptionsSuccess();
            updateTyreSizeConfiguratorFilterOptionsAction(response);
        } else {
            motoTyreFilterOptionsSuccess();
            updateTyreMotoSizeConfiguratorFilterOptionsAction(response);
        }
        
        if (false === doAutoOpen) {
            if (productType.TYRE_CAR === pageOriginType) {
            updateFilterOptionsAction(TyreFilterOptionsStore.getState());
            } else {
            updateFilterOptionsAction(TyreMotoFilterOptionsStore.getState());
            }
        }
    })
    .catch(() => {
        if (productType.TYRE_CAR === tyreType) {
            tyreFilterOptionsFailed();
        } else {
            motoTyreFilterOptionsFailed();
        }

        console.warn('Couldn\'t fetch ' + tyreType + ' configurator filter options');
    });

export const loadTyreConfiguratorFilterOptions = async function(doAutoOpen) {
    tyreFilterOptionsStarted();
    try {
        await getFilterOptions({
            apiPath: '/api/v2/configurator/size/filter-options/?type=' + productType.TYRE_CAR,
            data: '',
            dataType: 'json'
        }, productType.TYRE_CAR, doAutoOpen);
    } catch (error) {
        console.warn('Couldn\'t fetch tyre configurator filter options: ' + error);
    }
};

export const loadTyreMotoConfiguratorFilterOptions = async function(doAutoOpen) {
    motoTyreFilterOptionsStarted();
    try {
        await getFilterOptions({
            apiPath: '/api/v2/configurator/size/filter-options/?type=' + productType.TYRE_MOTO,
            data: '',
            dataType: 'json'
        }, productType.TYRE_MOTO, doAutoOpen);
    } catch (error) {
        console.warn('Couldn\'t fetch tyre moto configurator filter options: ' + error);
    }
};